/**
 * Errores de RPCs de acceso/EBP Equipo → copy friendly (nunca PostgREST/SQL raw).
 * Códigos internos se detectan en el message del RPC; el friendly va al usuario.
 */

const RAW_LOOKS_INTERNAL =
  /^(PGRST|JWT|JSON object|duplicate key|violates|permission denied for|column |relation |function |not_authenticated$|Failed to fetch|NetworkError|TypeError)/i;

const CODE_MESSAGES: Array<{ re: RegExp; message: string }> = [
  {
    re: /Team\.revoke/i,
    message: 'No tenés permiso para revocar o reactivar accesos.',
  },
  {
    re: /Team\.assign_branches/i,
    message: 'No tenés permiso para asignar sucursales.',
  },
  {
    re: /Team\.edit_permissions/i,
    message: 'No tenés permiso para editar permisos.',
  },
  {
    re: /cannot revoke self|cannot reactivate self|cannot edit own/i,
    message: 'No podés cambiar tu propio acceso desde acá.',
  },
  {
    re: /employee_not_found|employee_id_required/i,
    message: 'No encontramos a esa persona.',
  },
  {
    re: /branch_not_found|branch_org_mismatch|employee_id_and_branch_required/i,
    message: 'La sucursal no pertenece a este negocio.',
  },
  {
    re: /modules_required|module_required/i,
    message: 'Faltan módulos para guardar los permisos.',
  },
  {
    re: /not_authenticated/i,
    message: 'Sesión requerida. Volvé a iniciar sesión.',
  },
  {
    re: /Failed to fetch|NetworkError|network request failed|timeout/i,
    message: 'Sin conexión. Reintentá cuando vuelva la red.',
  },
];

export function mapTeamAccessError(
  input: { message?: string | null; code?: string | null } | string | null | undefined,
  fallback: string
): string {
  if (input == null) return fallback;

  const raw =
    typeof input === 'string'
      ? input.trim()
      : `${input.code ?? ''} ${input.message ?? ''}`.trim() || (input.message ?? '').trim();

  if (!raw) return fallback;

  for (const { re, message } of CODE_MESSAGES) {
    if (re.test(raw)) return message;
  }

  // Ya es copy friendly nuestra
  for (const { message } of CODE_MESSAGES) {
    if (raw === message) return message;
  }

  if (RAW_LOOKS_INTERNAL.test(raw)) return fallback;

  // Snake_case / códigos sueltos sin mapear → fallback (nunca al usuario)
  if (/^[a-z][a-z0-9_]+$/i.test(raw) && /_/.test(raw)) return fallback;

  if (
    msgLooksSpanishFriendly(raw) &&
    raw.length <= 180 &&
    !/module_permission_denied|permission denied/i.test(raw)
  ) {
    return raw;
  }

  return fallback;
}

function msgLooksSpanishFriendly(msg: string): boolean {
  return /[áéíóúñ]/i.test(msg) || /\b(no |la |el |tu |esta |tenés |podés )/i.test(msg);
}

export function teamAccessError(
  input: { message?: string | null; code?: string | null } | string | null | undefined,
  fallback: string
): Error {
  return new Error(mapTeamAccessError(input, fallback));
}
